import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import DashboardLayout from '../components/DashboardLayout';
import FounderCommandCenter from '../components/FounderCommandCenter';
import ApplicantDashboard from './ApplicantDashboard';

// Role-aware Home: admins/staff get the Founder Command Center; drivers/applicants
// keep their existing ApplicantDashboard (compliance/settlements/onboarding) unchanged.
const ADMIN_ROLES = ['admin', 'super_admin', 'ops_admin', 'safety_compliance_admin', 'payroll_admin', 'operations_admin'];

const HomeRouter = () => {
  const { user } = useAuth();
  if (user && user.role === 'partner_user') {
    return <Navigate to="/partner" replace />;
  }
  if (user && ADMIN_ROLES.includes(user.role)) {
    return (
      <DashboardLayout>
        <div data-testid="founder-home-page">
          <FounderCommandCenter />
        </div>
      </DashboardLayout>
    );
  }
  return <ApplicantDashboard />;
};

export default HomeRouter;
